import { render, staticRenderFns } from "./SnippetsEmphasizedNavButtons.vue?vue&type=template&id=a5e5b66c"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BasicLink: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/basic/BasicLink.vue').default})
